import { useActionHandler, ActionHandlerOptions } from "./useActionHandler";
import {
  getLocationCoordinates,
  createVenue,
  getFirstVenueId,
  getUserVenues,
  loadVenues,
  updateVenue,
  VenueUpdateData,
} from "@/server-side/actions/venue";
import { LocationParams } from "@/server-side/types";
import { VenueFormData } from "@/app/[locale]/venues/register/types";

export function useVenueActions() {
  const { handleAction } = useActionHandler();

  const getLocationCoordinatesAction = async (
    location: LocationParams,
    options?: ActionHandlerOptions
  ) => {
    return handleAction(getLocationCoordinates(location), options);
  };

  const createVenueAction = async (
    formData: VenueFormData,
    options?: ActionHandlerOptions
  ) => {
    return handleAction(createVenue(formData), options);
  };

  const getFirstVenueIdAction = async (
    userId: string,
    options?: ActionHandlerOptions
  ) => {
    return handleAction(getFirstVenueId(userId), options);
  };

  const getUserVenuesAction = async (
    userId: string,
    options?: ActionHandlerOptions
  ) => {
    return handleAction(getUserVenues(userId), options);
  };

  const loadVenuesAction = async (options?: ActionHandlerOptions) => {
    return handleAction(loadVenues(), options);
  };

  const updateVenueAction = async (
    venueId: string,
    updateData: VenueUpdateData,
    options?: ActionHandlerOptions
  ) => {
    return handleAction(updateVenue(venueId, updateData), options);
  };

  return {
    getLocationCoordinates: getLocationCoordinatesAction,
    createVenue: createVenueAction,
    getFirstVenueId: getFirstVenueIdAction,
    getUserVenues: getUserVenuesAction,
    loadVenues: loadVenuesAction,
    updateVenue: updateVenueAction,
  };
}
